import { render } from "./StoreRedirect.vue?vue&type=template&id=5cc92b9a&scoped=true"
import script from "./StoreRedirect.vue?vue&type=script&lang=js"
export * from "./StoreRedirect.vue?vue&type=script&lang=js"

import "./StoreRedirect.vue?vue&type=style&index=0&id=5cc92b9a&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cc92b9a"]])

export default __exports__